import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import OccupanySetpointController from "./OccupanySetpointController";
import ThermostatTileControls from "nx-components/Thermostat/TileControls";
import Platform from "nexia_mobile/platform";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import connect from "nexia_mobile/flux_like/store/connect";

export default connect(
  {
    isScreenReaderRunning: "isScreenReaderRunning",
  },
  class ThermostatTileControlsWrapper extends React.Component {
    static propTypes = {
      model: PropTypes.instanceOf(Backbone.Model).isRequired,
      isScreenReaderRunning: PropTypes.bool,
      showSpinner: PropTypes.func.isRequired, // () => void
      hideSpinner: PropTypes.func.isRequired, // () => void
    };

    state = {
      pendingHeatValue: null,
      pendingCoolValue: null,
    };

    _isEditing = false;

    shouldComponentUpdate() {
      // If the user is currently changing their setpoint, don't
      // override the setpoint with a new value, because it's
      // annoying to change stuff while the user is changing it.
      // We miss an update, but since they're about to
      // set a new value, that's fine.
      return !this._isEditing;
    }

    handleChangesStarted = () => {
      Dispatch("DISABLE_LOCATION_POLLING");
      this._isEditing = true;
    };

    handleChangesEnded = ({ setpointHeat, setpointCool }) => {
      Dispatch("ENABLE_LOCATION_POLLING");
      this._isEditing = false;
      const { model, showSpinner, hideSpinner } = this.props;
      if (
        setpointHeat === model.get("setpoint_heat") &&
        setpointCool === model.get("setpoint_cool")
      ) {
        // They didn't change anything
        return;
      }

      this.setState({
        pendingHeatValue: setpointHeat,
        pendingCoolValue: setpointCool,
      });
      showSpinner();
      const onDone = () => {
        this.setState({
          pendingHeatValue: null,
          pendingCoolValue: null,
        });
        hideSpinner();
      };
      model
        .setSetpoints({
          heat: setpointHeat,
          cool: setpointCool,
        })
        .then(onDone, onDone);
    };

    render() {
      const { model, isScreenReaderRunning } = this.props;
      const { pendingHeatValue, pendingCoolValue } = this.state;

      let changeBufferMs;
      if (
        Platform.canDetectIfScreenReaderIsRunning() &&
        isScreenReaderRunning
      ) {
        changeBufferMs = 6000;
      }

      return (
        <OccupanySetpointController model={model}>
          {({
            setpointCoolMin,
            setpointCoolMax,
            setpointHeatMin,
            setpointHeatMax,
            occupancyMode,
          }) => (
            <ThermostatTileControls
              isConnected={model.get("is_connected")}
              setpointHeat={pendingHeatValue || model.get("setpoint_heat")}
              setpointHeatMin={setpointHeatMin}
              setpointHeatMax={setpointHeatMax}
              setpointCool={pendingCoolValue || model.get("setpoint_cool")}
              setpointCoolMin={setpointCoolMin}
              setpointCoolMax={setpointCoolMax}
              setpointDelta={model.get("setpoint_delta")}
              setpointIncrement={model.get("setpoint_increment")}
              setpointLimitEnabled={model.get("setpoint_limit_enabled")}
              setpointLimit={model.get("setpoint_limit")}
              occupancyMode={occupancyMode}
              onChangesStarted={this.handleChangesStarted}
              onChangesEnded={this.handleChangesEnded}
              changeBufferMs={changeBufferMs}
            />
          )}
        </OccupanySetpointController>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/components/Controls/Thermostat/ThermostatTileControlsWrapper.jsx